<template>
  <div class="teamrewards">
    <toptitle :title1="titlework" />
    <section class="menu">
      <div @click="showPopup"
           class="choosedate">
        {{ dateSearch | datefmt }}
      </div>
      <div style="border-left: 1px solid #e5e5e5;"
           @click="showPopup2"
           class="choosedate">{{ rewardsDept }}</div>
      <van-popup v-model="show"
                 position="bottom">
        <van-datetime-picker show-toolbar
                             v-model="dateSearch"
                             title="选择年份"
                             type="year"
                             @confirm="onConfirm"
                             @cancel="onCancel"
                             :min-date="MinDate"
                             :max-date="MaxDate" />
      </van-popup>
      <van-popup v-model="show2"
                 position="bottom">
        <van-picker show-toolbar
                    :columns="columns2"
                    @confirm="onConfirm2"
                    @cancel="onCancel" />
      </van-popup>
    </section>

    <div class="edumessage">
      <van-row class="message-bg">
        <div class="message-bg1"></div>
        <van-col span="4">
          <p>姓名</p>
        </van-col>
        <van-col span="5">
          <p>调薪日期</p>
        </van-col>
        <van-col span="4">
          <p>原月薪</p>
        </van-col>
        <van-col span="4">
          <p>调整后</p>
        </van-col>
        <van-col span="7">
          <p>年薪涨幅比例</p>
        </van-col>
      </van-row>
      <van-empty v-show="emptyShow"
                 description="暂无数据" />
      <div>

        <van-row class="edumessage-bt"
                 v-for="(item,index) in salaryData"
                 :key="index">
          <van-col span="4">{{item.NAME}}</van-col>
          <van-col span="5">{{item.MODIFY_DAET}}</van-col>
          <van-col span="4">{{item.FORMER_COMPRATE}}</van-col>
          <van-col span="4">{{item.COMPRATE}}</van-col>
          <van-col span="7">{{item.RANGE}}</van-col>
        </van-row>

      </div>

      <loading-show :isLoadindShow="loading"></loading-show>
    </div>
  </div>
</template>

<script>
import toptitle from '../components/toptitle'
import dateformat from '@/utils/dateformat'
import LoadingShow from '../components/loading'
import { getMyDeptDataApi, getTeamSalaryadjust } from '../request/api'
export default {
  name: 'teamrp',
  data() {
    return {
      titlework: '团队调薪记录',
      active: 0,
      show: false,
      show2: false,
      emptyShow: false,
      loading: false,
      dateSearch: '',
      rewardsDept: '部门',
      MinDate: new Date(2010, 1, 1),
      MaxDate: new Date(),
      department: [],
      salaryData: [],
      columns: [],
      columns2: [],
    }
  },
  mounted() {
    this.getDeptList()
  },
  methods: {
    showPopup() {
      this.show = true
    },
    showPopup2() {
      this.show2 = true
    },

    onConfirm(value) {
      this.dateSearch = value
      this.show = false
      this.getTeamSalary()
    },
    onConfirm2(value) {
      this.rewardsDept = value
      this.show2 = false
      this.getTeamSalary()
    },

    onCancel() {
      this.show = false
      this.show2 = false
    },

    /**
     * 部门获取
     * **/
    getDeptList() {
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
      }
      getMyDeptDataApi(params).then((res) => {
        if (res.CODE === 200) {
          this.department = res.DATA

          this.columns2 = this.department.map((item) => {
            return item.DEPT_DESCR
          })
          if (this.rewardsDept == '部门') {
            this.rewardsDept = this.department[0].DEPT_DESCR
          }
          this.getTeamSalary()
        }
      })
    },
    /**
     * 团队调薪接口
     * **/
    getTeamSalary() {
      // let years = new Date(this.dateSearch)
      // let fullYear = years.getFullYear()
      this.loading = true
      //部门ID
      let departId = ''
      this.department.forEach((element) => {
        if (this.rewardsDept == element.DEPT_DESCR) {
          departId = element.DEPTID
        }
      })
      //  console.log(departId)
      let params = {
        DEPTID: departId,
        CURR_YEAR: dateformat('yyyy', this.dateSearch),
      }
      getTeamSalaryadjust(params).then((res) => {
        if (res.CODE === 200) {
          this.salaryData = res.DATA
          if (this.salaryData == 0) {
            this.emptyShow = true
          } else {
            this.emptyShow = false
          }
          this.loading = false
        }
      })
    },
  },
  components: {
    toptitle,
    LoadingShow,
  },
  filters: {
    datefmt(val) {
      //格式化日期查询条件的显示内容

      if (!val) return ''
      return dateformat('yyyy年', new Date(val))
    },
  },
  created() {
    //能选择的最大年份
    this.MaxDate = new Date(dateformat('yyyy-MM-01'))

    //默认为当前月份
    this.dateSearch = new Date(dateformat('yyyy-MM-01'))
  },
}
</script>

<style  lang="less" scoped>
.menu {
  display: flex;
  border-top: 1px solid #e5e5e5;
  div {
    box-shadow: 0;
  }
  .choosedate {
    width: 50%;
    background: white;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #323233;
    font-size: 15px;
    overflow: hidden;
  }
  .choosedate:after {
    display: inline-block;
    content: '';
    position: relative;
    top: 2px;
    margin-left: 3px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #999;
  }
}
.edumessage {
  border: 1px solid #f6f7f7;
  background: #fff;
  .edumessage-bt {
    font-size: 12px;
    line-height: 34px;
    text-align: center;
  }
}
.message-bg {
  .message-bg1 {
    width: 100%;
    height: 5px;
    background: #007fc6;
  }
  border: 1px solid #f6f7f7;
  border-radius: 3px;
  overflow: hidden;
  p {
    width: 100%;
    background: #f8f5f4;
    height: 35px;
    line-height: 35px;
    color: black;
    font-size: 12px;
    font-weight: 550;
    text-align: center;
  }
  section {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #343434;
    text-align: center;
  }
}
.divname {
  color: #333;
}
</style>